import { appConfig } from "../config";

export type UserDataSource =
  | { kind: "spreadsheet"; sheetId: string }
  | { kind: "cloudflare-d1"; endpoint: string; token: string };

export function normalizeEndpoint(value: string): string {
  return value.trim().replace(/\/+$/, "");
}

export function isDataSourceConfigured(source: UserDataSource): boolean {
  return source.kind === "spreadsheet"
    ? Boolean(source.sheetId)
    : Boolean(normalizeEndpoint(source.endpoint) && source.token.trim());
}

export function dataSourceCacheId(source: UserDataSource): string {
  return source.kind === "spreadsheet" ? `sheet:${source.sheetId}` : `d1:${normalizeEndpoint(source.endpoint)}`;
}

export function dataSourceGetUrl(source: UserDataSource, method: string): URL {
  const url = new URL(source.kind === "spreadsheet" ? appConfig.aipriDbApiUrl : normalizeEndpoint(source.endpoint));
  url.searchParams.set("method", method);
  if (source.kind === "spreadsheet" && source.sheetId) url.searchParams.set("sheetID", source.sheetId);
  return url;
}

export function dataSourceRequestInit(
  source: UserDataSource,
  payload?: Record<string, unknown>,
): RequestInit {
  const headers = new Headers();
  if (source.kind === "cloudflare-d1") {
    headers.set("Authorization", `Bearer ${source.token.trim()}`);
  }
  if (!payload) return { headers, cache: "no-store" };
  if (source.kind === "spreadsheet") {
    headers.set("Content-Type", "application/x-www-form-urlencoded");
    return { method: "POST", headers, body: JSON.stringify({ sheetID: source.sheetId, ...payload }) };
  }
  headers.set("Content-Type", "application/json");
  return { method: "POST", headers, body: JSON.stringify(payload) };
}
